if (!customElements.get('empty-cart-product-slider')) {
    class EmptyCartProductSlider extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.buttonText = 'Add to Cart';
        this.isInitialized = false;
    }

    connectedCallback() {
        this.init();
    }
    
    init() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
    
        this.initializeSwiper();
        this.setupVariantSelection();
        this.initializeProductStates();
    } 

    disconnectedCallback() {
        if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
        }
        this.isInitialized = false;
    }

    initializeSwiper() {
        if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
        }

        if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initializeSwiper(), 100);
        return;
        }

        const swiperContainer = this.querySelector('.cart-empty-cart-product-slider__swiper');
        if (!swiperContainer) return;

        const slides = swiperContainer.querySelectorAll('.swiper-slide');
        if (slides.length === 0) return;

        const isDesktop = window.innerWidth >= 750;

        this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        speed: 300,
        allowTouchMove: !isDesktop,
        pagination: {
            el: swiperContainer.querySelector('.swiper-pagination'),
            clickable: true,
            dynamicBullets: false,
        },
        navigation: {
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
        },
        grabCursor: !isDesktop,
        watchOverflow: true,
        breakpoints: {
            750: {
            slidesPerView: 2,
            spaceBetween: 20,
            },
        },
        });

        let resizeTimer;
        window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const newIsDesktop = window.innerWidth >= 750;
            if (this.swiper) {
            this.swiper.allowTouchMove = !newIsDesktop;
            this.swiper.params.allowTouchMove = !newIsDesktop;
            this.swiper.params.grabCursor = !newIsDesktop;
            this.swiper.update();
            }
        }, 250);
        });
    }

    setupVariantSelection() {
        if (this.isInitialized) {
        return;
        }

        const productContainers = this.querySelectorAll('.cart-empty-cart-product-slider__product');
        
        productContainers.forEach(container => {
        const selects = container.querySelectorAll('.cart-empty-cart-product-slider__variant-select');
        
        selects.forEach(select => {
            select.addEventListener('change', () => {
            this.updateVariantSelection(container);
            });
        });
        });

        this.isInitialized = true;
    }

    initializeProductStates() {
        const productContainers = this.querySelectorAll('.cart-empty-cart-product-slider__product');
        
        productContainers.forEach(container => {
        const selects = container.querySelectorAll('.cart-empty-cart-product-slider__variant-select');
        const addButton = container.querySelector('.cart-empty-cart-product-slider__button');
        
        if (selects.length === 0) {
            return;
        }

        let allOptionsSelected = true;
        selects.forEach(select => {
            if (!select.value || select.value === '') {
            allOptionsSelected = false;
            }
        });
        
        if (allOptionsSelected) {
            this.updateVariantSelection(container);
        } else {
            if (addButton) {
            addButton.disabled = true;
            addButton.textContent = this.buttonText;
            }
        }
        });
    }

    updateVariantSelection(productContainer) {
        const selects = productContainer.querySelectorAll('.cart-empty-cart-product-slider__variant-select');
        const variantIdInput = productContainer.querySelector('.cart-empty-cart-product-slider__variant-id');
        const addButton = productContainer.querySelector('.cart-empty-cart-product-slider__button');
        const preorderPropertyInput = productContainer.querySelector('.cart-empty-cart-product-slider__preorder-property');

        if (selects.length === 0) {
        if (variantIdInput && addButton) {
            const productId = variantIdInput.dataset.productId;
            const productData = this.getProductData(productId, productContainer);
            
            if (productData && productData.variants && productData.variants.length > 0) {
            const variant = productData.variants[0];
            if (variant.available) {
                addButton.disabled = false;
            } else {
                addButton.disabled = true;
                addButton.textContent = 'Out Of Stock';
            }
            }
        }
        return;
        }

        const productId = selects[0].dataset.productId;
        let productData = this.getProductData(productId, productContainer);
        
        if (!productData || !productData.options || !productData.variants) {
        if (variantIdInput) {
            variantIdInput.value = '';
            variantIdInput.disabled = true;
        }
        if (preorderPropertyInput) {
            preorderPropertyInput.value = '';
            preorderPropertyInput.disabled = true;
        }
        if (addButton) {
            addButton.disabled = true;
            addButton.textContent = this.buttonText;
        }
        return;
        }

        const selectedOptions = [];
        let allSelected = true;

        productData.options.forEach((optionName, index) => {
        const select = Array.from(selects).find(s => s.dataset.optionName === optionName);
        if (select && select.value && select.value !== '') {
            selectedOptions[index] = select.value;
        } else {
            allSelected = false;
            selectedOptions[index] = null;
        }
        });

        if (!allSelected) {
        if (variantIdInput) {
            variantIdInput.value = '';
            variantIdInput.disabled = true;
        }
        if (preorderPropertyInput) {
            preorderPropertyInput.value = '';
            preorderPropertyInput.disabled = true;
        }
        if (addButton) {
            addButton.disabled = true;
            addButton.textContent = this.buttonText;
        }
        return;
        }

        const matchingVariant = productData.variants.find(variant => {
        if (!variant.options || variant.options.length !== selectedOptions.length) {
            return false;
        }
        return variant.options.every((option, index) => option === selectedOptions[index]);
        });

        if (matchingVariant) {
        if (variantIdInput) {
            variantIdInput.value = matchingVariant.id;
            variantIdInput.disabled = false;
        }

        const selectedOption = this.getSelectedOptionElement(productContainer, selectedOptions);
        const isPreorder = selectedOption?.dataset.preorderEnabled === 'true';
        const deliveryDate = selectedOption?.dataset.preorderDelivery || '';
        const customAtcText = selectedOption?.dataset.atcText || this.buttonText;

        if (preorderPropertyInput) {
            if (isPreorder && deliveryDate) {
            preorderPropertyInput.value = 'Estimated delivery date is ' + deliveryDate.trim() + '.';
            preorderPropertyInput.disabled = false;
            } else {
            preorderPropertyInput.value = '';
            preorderPropertyInput.disabled = true;
            }
        }

        if (addButton) {
            if (matchingVariant.available) {
            addButton.disabled = false;
            addButton.removeAttribute('disabled');
            addButton.textContent = isPreorder ? customAtcText : this.buttonText;
            } else {
            addButton.disabled = true;
            addButton.textContent = 'Out Of Stock';
            }
        }
        } else {
        if (variantIdInput) {
            variantIdInput.value = '';
            variantIdInput.disabled = true;
        }
        if (preorderPropertyInput) {
            preorderPropertyInput.value = '';
            preorderPropertyInput.disabled = true;
        }
        if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Unavailable';
        }
        }
    }

    getSelectedOptionElement(productContainer, selectedOptions) {
        const selects = productContainer.querySelectorAll('.cart-empty-cart-product-slider__variant-select');
        const productId = selects[0]?.dataset.productId;
        
        if (!productId) return null;
        
        const productData = this.getProductData(productId, productContainer);
        if (!productData || !productData.options) return null;
        
        for (let i = 0; i < productData.options.length; i++) {
        if (selectedOptions[i]) {
            const optionName = productData.options[i];
            const select = Array.from(selects).find(s => s.dataset.optionName === optionName);
            
            if (select && select.value === selectedOptions[i]) {
            const selectedOption = select.querySelector(`option[value="${selectedOptions[i]}"]`);
            if (selectedOption && selectedOption.dataset.preorderEnabled) {
                return selectedOption;
            }
            }
        }
        }
        
        for (const select of selects) {
        if (select.value) {
            const selectedOption = select.querySelector(`option[value="${select.value}"]`);
            if (selectedOption && selectedOption.dataset.preorderEnabled === 'true') {
            return selectedOption;
            }
        }
        }
        
        return null;
    }

    getProductData(productId, productContainer) {
        if (!productId) return null;
        
        if (window.cartAddonVariants?.[productId]) {
        const data = window.cartAddonVariants[productId];
        if (data && (data.variants || data.options)) {
            return data;
        }
        }

        const scriptTag = productContainer.querySelector('script');
        if (scriptTag && scriptTag.textContent) {
        try {
            eval(scriptTag.textContent);
            if (window.cartAddonVariants?.[productId]) {
            const data = window.cartAddonVariants[productId];
            if (data && (data.variants || data.options)) {
                return data;
            }
            }
        } catch (error) {
            return null;
        }
        }

        const allScripts = document.querySelectorAll('script');
        for (let script of allScripts) {
        if (script.textContent && script.textContent.includes(`window.cartAddonVariants[${productId}]`)) {
            try {
            eval(script.textContent);
            if (window.cartAddonVariants?.[productId]) {
                const data = window.cartAddonVariants[productId];
                if (data && (data.variants || data.options)) {
                return data;
                }
            }
            } catch (error) {
            return null;
            }
        }
        }

        const selects = productContainer.querySelectorAll('.cart-empty-cart-product-slider__variant-select');
        if (selects.length > 0) {
        const optionNames = [];
        selects.forEach(select => {
            const optionName = select.dataset.optionName;
            if (optionName && !optionNames.includes(optionName)) {
            optionNames.push(optionName);
            }
        });

        if (optionNames.length > 0) {
            return {
            options: optionNames,
            variants: []
            };
        }
        }

        return null;
    }
    }

    customElements.define('empty-cart-product-slider', EmptyCartProductSlider);
}